import {
    RouterProvider,
    createBrowserRouter,
    Navigate,
} from "react-router-dom";

import "./App.scss";

import { IncludeLocalization } from "./components/localization/Localization";

import Main from "./pages/main/Main";
import Admin from "./pages/admin-panel/Admin"
import Test from "./react_jwt_auth"

const router = createBrowserRouter([
    { path: "/", element: <Navigate to="/en/" replace /> },
    { path: "*", element: <Navigate to="/" replace /> },
    {
        path: "/:lang",
        element: <IncludeLocalization />,
        children: [
            {
                path: "",
                element: <Main />,
            },
        ],
    },
    {
        path: "/admin",
        element: <Admin />,
    },
    {
        path: "/test",
        element: <Test />,
    },
]);

function App() {
    return (
        <div className="App">
            <RouterProvider router={router} />
        </div>
    );
}

export default App;
